import { useState } from "react";
export const usePagination = (allItems, perPage, firstLoad) => {
    const [showedItems, setShowedItems] = useState(firstLoad || perPage);
    const loadMore = () => setShowedItems(showedItems + perPage);
    const reset = () => setShowedItems(firstLoad || perPage);
    const items = allItems?.slice(0, showedItems);
    return [items, loadMore, reset];
};
//# sourceMappingURL=usePagination.js.map